import { render, staticRenderFns } from "./FormP2.vue?vue&type=template&id=37e6133c&scoped=true"
import script from "./FormP2.vue?vue&type=script&lang=ts"
export * from "./FormP2.vue?vue&type=script&lang=ts"
import style0 from "./FormP2.vue?vue&type=style&index=0&id=37e6133c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e6133c",
  null
  
)

export default component.exports